/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React from 'react';
import { Typography, Checkbox as MuiCheckbox, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  checkbox: {
    padding: 0
  }
});

export default function Checkbox({ label, onChange }) {
  const classes = useStyles();
  return (
    <div className="checkbox-container">
      <div className="checkbox-input-container">
        <MuiCheckbox id="confirm" name="confirm" onChange={onChange} color="primary" className={classes.checkbox} />
      </div>
      <div className="checkbox-label-container">{label && <Typography>{label}</Typography>}</div>
    </div>
  );
}
